
import { Component, OnInit, OnDestroy, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Router } from '@angular/router';
import { BreadcrumbService } from '@k12/navigation';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-user-record-view-employees',
  imports: [MatButtonModule, MatIconModule, MatProgressBarModule],
  templateUrl: './user-record-view-employees.component.html'
})
export class UserRecordViewEmployeesComponent implements OnInit, OnDestroy {
  // Input for services that need to be injected from the consuming application
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() employeeService: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() userRecordService: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public personaId: any = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userId: any = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userData: any = null;
  private breadcrumbService = inject(BreadcrumbService);
  private router = inject(Router);

  public ngOnDestroy(): void {
    this.breadcrumbService.clearDynamicBreadcrumbs();
  }

  public ngOnInit(): void {
    if (history.state && history.state['personaId']) {
      this.personaId = history.state['personaId'];
    }

    if (history.state && history.state['providerId']) {
      this.userId = history.state['providerId'];
    }

    this.getUserDataForBreadcrumbs();
    this.getData();
    document.documentElement.scrollTop = 0;
  }

  getData() {
    if (!this.employeeService) return;
    const payload = {
      Filter: {
        PageNumber: 1,
        PageSize: 10
      }
    };
    this.employeeService.GetAllEmployeesSummaryAdmin(this.userId, payload).subscribe();
  }

  // Method to get user data and set breadcrumbs
  private getUserDataForBreadcrumbs(): void {
    if (this.userId && this.userRecordService) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.userRecordService.getProviderDetails(this.userId).subscribe((res: any) => {
        this.userData = res;
      });
    }
    this.setBreadcrumbsForViewEmployees();
  }

  // Method to set breadcrumbs for the view employees page
  private setBreadcrumbsForViewEmployees(): void {
    if (this.userData && this.userData.firstName && this.userData.lastName) {
      const userName = `${this.userData.firstName} ${this.userData.lastName}`;
      // Set breadcrumbs for user record and view employees pages
      this.breadcrumbService.setNestedDynamicBreadcrumbs(
        // eslint-disable-next-line sonarjs/no-duplicate-string
        '/work-queue',
        this.userId,
        userName,
        undefined,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        'View Employees'
      );
    } else if (this.userRecordService) {
      const routeSegments = this.router.url.split('/');
      const userId = routeSegments[2];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.userRecordService.getProviderDetails(userId).subscribe((res: any) => {
        if (res) {
          if (res.businessName) {
            this.breadcrumbService.setNestedDynamicBreadcrumbs(
              '/work-queue',
              userId,
              res.businessName,
              undefined,
              'View Employees'
            );
          } else if (res.firstName && res.lastName) {
            const userName = `${res.firstName} ${res.lastName}`;
            this.breadcrumbService.setNestedDynamicBreadcrumbs(
              '/work-queue',
              userId,
              userName,
              undefined,
              'View Employees'
            );
          }
        }
      });
    }
  }
}

